export const dataStates = {
  INIT: 'initialising',
  FETCHING: 'fetching',
  VALIDATIONERROR: 'validationerror',
  ERROR: 'error',
  SUCCESS: 'success',
};
